import Barba from 'barba.js'
import {TweenLite, CSSPlugin, AttrPlugin} from 'gsap/TweenMax'

const plugins = [CSSPlugin, AttrPlugin];

export default Barba.BaseView.extend({
    namespace: 'vantages',
    speed: .5,
    animating: false,
    active: null,
    click: null,
    elements: null,
    onEnter() {
        this.click = this.__click.bind(this);
    },
    onEnterCompleted() {
        this.elements = document.querySelectorAll('.advantages-wrapper .advantage');
        this.elements.forEach(el => el.addEventListener('click', this.click))
    },
    onLeave() {
        this.elements.forEach(el => el.removeEventListener('click', this.click))
        this.elements = null;
    },
    onLeaveCompleted() {
        this.click = null;
    },
    __click(ev) {
        if (this.animating) return;

        if (ev.currentTarget.classList.contains('open')) return this.close( ev.currentTarget );

        const open = document.querySelector('.advantages-wrapper .advantage.open')

        if (open) {
            let element = ev.currentTarget;
            return this.close( open ).then( () => this.open(element) )
        }

        this.open(ev.currentTarget);
    },
    open(element) {
        let row = element.parentElement;

        this.animating = true;
        element.classList.add('open');
        let dropdown = element.querySelector('.dropdown');
        if( matchMedia('(min-width: 768px)').matches ) {
            TweenLite.to(row, this.speed, {marginBottom: dropdown.scrollHeight});
        } else {
            TweenLite.to(element, this.speed, {marginBottom: dropdown.scrollHeight});
        }
        TweenLite.to(dropdown, this.speed, {
            height: dropdown.scrollHeight,
            onCompleteScope: this,
            onComplete() {
                this.animating = false;
            }
        })
    },
    close( element ) {
        let row = element.parentElement;
        this.animating = true;
        let dropdown = element.querySelector('.dropdown');

        return new Promise( ( resolve, reject ) => {
            if( matchMedia('(min-width: 768px)').matches ) {
                TweenLite.to(row, this.speed, {marginBottom: 0});
            } else {
                TweenLite.to(element, this.speed, {marginBottom: 5});
            }
            TweenLite.to(dropdown, this.speed, {
                height: 0,
                onCompleteScope: this,
                onComplete() {
                    this.animating = false;
                    element.classList.remove('open');
                    resolve();
                }
            })
        });
    }
})